export default {
  title: '经销商管理',
  dealerList: '经销商列表',
};
